<template>
    <ul :class="wrapClasses" :style="styles" v-else>
      <span :class="[prefixCls + '-total']" v-if="showTotal">
          <slot>{{ t('i.page.total') }} {{ total }} 
              <template v-if="total <= 1">{{ t('i.page.item') }}</template>
              <template v-else>{{ t('i.page.items') }}</template>
          </slot>
      </span>
      <li :class="prevClasses" @click="prev">
          <a>
              <template v-if="prevText !== ''">{{ prevText }}</template>
              <i v-else class="ivu-icon ivu-icon-ios-arrow-back"></i>
          </a>
      </li>
      <li :class="firstPageClasses" @click="changePage(1)">
          <a>1</a>
      </li>
      <li v-show="prevMore()" :class="[prefixCls + '-item-jump-prev']" @click="fastPrev">
          <a>
              <i class="ivu-icon ivu-icon-ios-arrow-back"></i>
              <i class="ivu-icon ivu-icon-ios-more"></i>
          </a>
      </li>
      <li v-show="prevFour()" :class="[prefixCls + '-item']" @click="changePage(currentPage - 4)">
          <a>{{ currentPage - 4 }}</a>
      </li>
      <li v-show="prevThree()" :class="[prefixCls + '-item']" @click="changePage(currentPage - 3)">
          <a>{{ currentPage - 3 }}</a>
      </li>
      <li v-show="prevTwo()" :class="[prefixCls + '-item']" @click="changePage(currentPage - 2)">
          <a>{{ currentPage - 2 }}</a>
      </li>
      <li v-show="prevOne()" :class="[prefixCls + '-item']" @click="changePage(currentPage - 1)">
          <a>{{ currentPage - 1 }}</a>
      </li>
      <li v-show="currentPage != 1 && currentPage != allPages" :class="[prefixCls + '-item',prefixCls + '-item-active']">
          <a>{{ currentPage }}</a>
      </li>
      <li v-show="nextOne()" :class="[prefixCls + '-item']" @click="changePage(currentPage + 1)">
          <a>{{ currentPage + 1 }}</a>
      </li>
      <li v-show="nextTwo()" :class="[prefixCls + '-item']" @click="changePage(currentPage + 2)">
          <a>{{ currentPage + 2 }}</a>
      </li>
      <li v-show="nextThree()" :class="[prefixCls + '-item']" @click="changePage(currentPage + 3)">
          <a>{{ currentPage + 3 }}</a>
      </li>
      <li v-show="nextFour()" :class="[prefixCls + '-item']" @click="changePage(currentPage + 4)">
          <a>{{ currentPage + 4 }}</a>
      </li>
      <li v-show="nextMore()" :class="[prefixCls + '-item-jump-next']" @click="fastNext">
          <a>
              <i class="ivu-icon ivu-icon-ios-arrow-forward"></i>
              <i class="ivu-icon ivu-icon-ios-more"></i>
          </a>
      </li>
      <li v-if="allPages > 1" :class="lastPageClasses" @click="changePage(allPages)">
          <a>{{ allPages }}</a>
      </li>
      <li :class="nextClasses" @click="next">
          <a>
              <template v-if="nextText !== ''">{{ nextText }}</template>
              <i v-else class="ivu-icon ivu-icon-ios-arrow-forward"></i>
          </a>
      </li>
    </ul>
  </template>
  <script>
    const prefixCls = 'ivu-page';
  
    export default {
        name: 'Page',
        components: {},
        props: {
            current: {
                type: Number,
                default: 1
            },
            total: {
                type: Number,
                default: 0
            },
            pageSize: {
                type: Number,
                default: 10
            },
            pageSizeOpts: {
                type: Array,
                default () {
                    return [10, 20, 30, 40];
                }
            },
            transfer: {
                type: Boolean,
                default () {
                    return !this.$IVIEW || this.$IVIEW.transfer === '' ? false : this.$IVIEW.transfer;
                }
            },
            simple: {
                type: Boolean,
                default: false
            },
            showTotal: {
                type: Boolean,
                default: false
            },
            showElevator: {
                type: Boolean,
                default: false
            },
            showSizer: {
                type: Boolean,
                default: false
            },
            className: {
                type: String
            },
            styles: {
                type: Object
            },
            prevText: {
                type: String,
                default: ''
            },
            nextText: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            // 4.6.0
            eventsEnabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                prefixCls: prefixCls,
                currentPage: this.current,
                currentPageSize: this.pageSize
            };
        },
        watch: {
            total (val) {
                let maxPage = Math.ceil(val / this.currentPageSize);
                if (maxPage < this.currentPage ) {
                    this.currentPage = (maxPage === 0 ? 1 : maxPage);
                }
            },
            current (val) {
                this.currentPage = val;
            },
            pageSize (val) {
                this.currentPageSize = val;
            }
        },
        computed: {
            
            isSmall () {
                return !!this.size;
            },
            allPages () {
                const allPage = Math.ceil(this.total / this.currentPageSize);
                return (allPage === 0) ? 1 : allPage;
            },
            wrapClasses () {
                return [
                    `${prefixCls}`,
                    {
                        [`${this.className}`]: !!this.className,
                        [`${prefixCls}-with-disabled`]: this.disabled,
                        'mini': !!this.size
                    }
                ];
            },
            prevClasses () {
                return [
                    `${prefixCls}-prev`,
                    {
                        [`${prefixCls}-disabled`]: this.currentPage === 1 || this.disabled,
                        [`${prefixCls}-custom-text`]: this.prevText !== ''
                    }
                ];
            },
            nextClasses () {
                return [
                    `${prefixCls}-next`,
                    {
                        [`${prefixCls}-disabled`]: this.currentPage === this.allPages || this.disabled,
                        [`${prefixCls}-custom-text`]: this.nextText !== ''
                    }
                ];
            },
            firstPageClasses () {
                return [
                    `${prefixCls}-item`,
                    {
                        [`${prefixCls}-item-active`]: this.currentPage === 1
                    }
                ];
            },
            lastPageClasses () {
                return [
                    `${prefixCls}-item`,
                    {
                        [`${prefixCls}-item-active`]: this.currentPage === this.allPages
                    }
                ];
            }
        },
      methods: {
          t(value){
              if(value == 'i.page.total'){
                  return '共';
              }else if(value == 'i.page.items' || value == 'i.page.item'){
                  return '个'
              }
              },
          changePage (page) {
              if (this.disabled) return;
              if (this.currentPage != page) {
                  this.currentPage = page;
                  this.$emit('update:current', page);
                  this.$emit('on-change', page);
              }
          },
          prev () {
              if (this.disabled) return;
              const current = this.currentPage;
              if (current <= 1) {
                  return false;
              }
              this.changePage(current - 1);
          },
          next () {
              if (this.disabled) return;
              const current = this.currentPage;
              if (current >= this.allPages) {
                  return false;
              }
              this.changePage(current + 1);
          },
          fastPrev () {
              if (this.disabled) return;
              const page = this.currentPage - 5;
              if (page > 0) {
                  this.changePage(page);
              } else {
                  this.changePage(1);
              }
          },
          fastNext () {
              if (this.disabled) return;
              const page = this.currentPage + 5;
              if (page > this.allPages) {
                  this.changePage(this.allPages);
              } else {
                  this.changePage(page);
              }
          },
          onSize (pageSize) {
              if (this.disabled) return;
              this.currentPageSize = pageSize;
              this.$emit('on-page-size-change', pageSize);
              this.changePage(1);
          },
          onPage (page) {
              if (this.disabled) return;
              this.changePage(page);
          },
          keyDown (e) {
              const key = e.keyCode;
              const condition = (key >= 48 && key <= 57) || (key >= 96 && key <= 105) || key === 8 || key === 37 || key === 39;
  
              if (!condition) {
                  e.preventDefault();
              }
          },
          keyUp (e) {
              const key = e.keyCode;
              const val = parseInt(e.target.value);
  
              if (key === 38) {
                  this.prev();
              } else if (key === 40) {
                  this.next();
              } else if (key === 13) {
                  let page = 1;
  
                  if (val > this.allPages) {
                      page = this.allPages;
                  } else if (val <= 0 || !val) {
                      page = 1;
                  } else {
                      page = val;
                  }
  
                  e.target.value = page;
                  this.changePage(page);
              }
          },
          prevMore(){
              if(this.allPages == 7 && this.currentPage == 4){
                  return true;
              }else if(this.allPages > 5 && this.currentPage >= 5){
                  return true;
              }
              return false;
          },
          prevOne(){
              if(this.allPages == 5 && this.currentPage == 1){
                  return false;
              }else if(this.allPages == 6 && this.currentPage == 1){
                  return false;
              }else if(this.allPages == 6 && this.currentPage == 2){
                  return false;
              }else if(this.allPages == 7 && this.currentPage == 2){
                  return false;
              }else if(this.currentPage == this.allPages - 4){
                  return true;
              }else if(this.currentPage == this.allPages - 5){
                  return true;
              }else if(this.currentPage - 1 > 1){
                  return true;
              }
              return false;
          },
          prevTwo(){
              if(this.allPages > 15){
                  if(this.currentPage == this.allPages - 4){
                      return true;
                  }else if(this.currentPage == this.allPages - 3){
                      return true;
                  }else if(this.currentPage - 2 > 1){
                      return true;
                  }
                  return false;
              }else if(this.allPages <= 14){
                  if(this.currentPage == this.allPages - 3){
                      return false;
                  }else if(this.currentPage - 2 > 1){
                      return true;
                  }
                  return false;
              }
          },
          prevThree(){
              if(this.allPages < 5){
                  return false;
              }else if(this.allPages == 7 && this.currentPage == 6){
                  return true;
              }else if(this.allPages == 7 && this.currentPage == 5){
                  return false;
              }else if(this.allPages == 7 && this.currentPage == this.allPages - 2){
                  return true;
              }else if(this.allPages == 6 && this.currentPage == this.allPages - 1){
                  return true;
              }else if(this.allPages == 5 && this.currentPage == this.allPages - 1){
                  return false;
              }else if(this.currentPage == this.allPages){
                  return true;
              }else if(this.currentPage == this.allPages - 1){
                  return true;
              }else{
                  return false;
              }
          },
          prevFour(){
              if(this.allPages < 5){
                  return false;
              }else if(this.allPages == 5 && this.currentPage == 5){
                  return false;
              }else if(this.currentPage == this.allPages){
                  return true;
              }
              return false;
          },
          nextOne(){
              if(this.allPages > this.currentPage + 1){
                  return true;
              }
              return false;
          },
          nextTwo(){
              if(this.allPages < 4){
                  return false
              }else if(this.allPages == 7 && this.currentPage == 4){
                  return true;
              }else if(this.allPages == 7 && this.currentPage == 5){
                  return false;
              }else if(this.allPages == 7 && this.currentPage == 6){
                  return false;
              }else{
                  if(this.currentPage == 1){
                      return true;
                  }else if(this.currentPage != 4 && this.allPages > this.currentPage + 2){
                      return true;
                  }
              }
              return false;
          },
          nextThree(){
              if(this.allPages > 7){
                  if(this.currentPage == 1 || this.currentPage == 2){
                      return true;
                  }else if(this.currentPage == this.allPages - 4){
                      return false;
                  }
              }else if(this.allPages == 7 && this.currentPage == 1){
                  return true;
              }else if(this.allPages == 7 && this.currentPage == 2){
                  return true;
              }else if(this.allPages == 6 && this.currentPage == 1){
                  return true;
              }else if(this.allPages == 6 && this.currentPage == 2){
                  return true;
              }else if(this.allPages == 5 && this.currentPage == 1){
                  return true;
              }else if(this.allPages == 5 && this.currentPage == 2){
                  return false;
              }
              return false;
          },
          nextFour(){
              if(this.allPages > 5){
                  if(this.currentPage == 1){
                      return true;
                  }
              }
              return false;
          },
          nextMore(){
              if(this.allPages <= 5){
                  return false;
              }else if(this.allPages - this.currentPage >= 4){
                  return true;
              }
              return false;
          }
      }
    };
  </script>